// const BASE_URL = 'https://2hkrtu5red.execute-api.ap-northeast-1.amazonaws.com/V1/api-master?'
// 試験環境
// const BASE_URL = 'https://master-apitest.hakaru-rakusuru.jp/api-master-dynamodb?'
const BASE_URL = 'https://admin-aptest.hakaru-rakusuru.jp/api-master-dynamodb?'
// 本番環境
// const BASE_URL = 'https://master-api.hakaru-rakusuru.jp/api-master-dynamodb?'
// const BASE_URL = 'https://admin-ap.hakaru-rakusuru.jp/api-master-dynamodb?'

export default BASE_URL;